import Macy from 'macy';
import resizeStore from '../resize/resize.store';

class MasonryViewElement extends HTMLElement{
    constructor() {
        super();

        this._hide = this.dataset.hide;
        this._initialized = null;

        let columns = 0;
        if (this.querySelectorAll('.masonry-item').length) columns = 1;

        this.onResize = () => this._onResize();
    }
    connectedCallback() {
        this._onResize();
        resizeStore.eventEmitter.addListener(this.onResize);
    }
    disconnectedCallback() {
        resizeStore.eventEmitter.removeListener(this.onResize);
    }

    _init() {
        this._macy = new Macy({
            container: this,
            waitForImages: false,
            margin: {
                x: 25,
                y: 50
            },
            mobileFirst: false,
            columns: 5,
        });
    }
    _onResize() {
        let vw = resizeStore.getData().width;

        if (vw < this._hide && this._initialized) {
            this._macy.remove();
            this._initialized = false
        }
        if (vw > this._hide) {
            this._initialized = true;
            this._init();
        }
    }
}

window.customElements.define('masonry-view', MasonryViewElement);
